define('FilterCommerceCatalog.EntryPoint',
  [
    'ItemsSearcher.Collection',
    'Item.Collection',
    'GeoLocation.Service',
    'underscore'
  ],
  function (
    ItemsSearcherCollection,
    ItemCollection,
    GeoLocationService,
    _
  ) {

    'use strict';

    return {
      mountToApp: function mountToApp(container) {
        var FIELDS = {
          activebowls: { au: 'custitem_uc_in_stock_au_m_p_bd1', nz: null },
          henselite: { au: 'custitem_uc_in_stock_au_bd1', nz: 'custitem_uc_in_stock_nzd_nz1' }
        };

        var environment = container.getComponent('Environment');
        var host = window.location.host;
        var currentUrl = this.formatForUrl(host);

        var domainFields = host.indexOf('henselite') !== -1 ? FIELDS.henselite : FIELDS.activebowls;

        var stockField = domainFields.au;

        if (domainFields.nz) {
          GeoLocationService.getLocation()
            .done(function (location) {
              stockField = location.isNZ ? domainFields.nz : domainFields.au;
            });
        }

        if (environment) {
          environment.defineSearchMasterOptions(
            'Facets',
            function (searchApiMasterOptions) {
              searchApiMasterOptions['custitem_uc_website_visibility'] = currentUrl;
              if (stockField) {
                searchApiMasterOptions[stockField] = 'T';
              }
              return searchApiMasterOptions;
            }
          );
        }

        _.extend(ItemsSearcherCollection.prototype, {
          fetch: function (options) {
            // eslint-disable-next-line no-param-reassign
            options = options || {};
            options.cache = true;
            this.arguments = arguments;
            this.arguments[0].data['custitem_uc_website_visibility'] = currentUrl;
            if (stockField) {
              this.arguments[0].data[stockField] = 'T';
            }
            return ItemCollection.prototype.fetch.apply(this, arguments);
          }
        });
      },

      formatForUrl: function (text) {
        var textToFormat = text;
        var replaceableCharacters = [
          {character: '-', encodedValue: '~'},
          {character: '/', encodedValue: '-SLASH-'},
          {character: '&(?!amp;)', encodedValue: '-AND-'},
          {character: ',', encodedValue: '%2C'},
          {character: "'", encodedValue: '%27'},
          {character: ' ', encodedValue: '-'}
        ];

        _.each(replaceableCharacters, function (replaceableCharacter) {
          var expression = new RegExp(replaceableCharacter.character, 'g');
          textToFormat = textToFormat.replace(expression, replaceableCharacter.encodedValue);
        });

        return textToFormat;
      }
    };
  }
);
